import { render, staticRenderFns } from "./IVolume.vue?vue&type=template&id=4eae061c&"
import script from "./IVolume.vue?vue&type=script&lang=ts&"
export * from "./IVolume.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports